import { render, staticRenderFns } from "./MyfinbizChatSurvey.vue?vue&type=template&id=ddee093c&scoped=true&"
import script from "./MyfinbizChatSurvey.vue?vue&type=script&lang=js&"
export * from "./MyfinbizChatSurvey.vue?vue&type=script&lang=js&"
import style0 from "./MyfinbizChatSurvey.vue?vue&type=style&index=0&id=ddee093c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddee093c",
  null
  
)

export default component.exports